import axios, { AxiosInstance } from 'axios';
import { getApiUrl } from '../../lib/services/urls';
import { reportHttpError } from '../../lib/sentry';

import { PATIENT_TOKEN_KEY } from './PatientAuthContext';

const patientAxios: AxiosInstance = axios.create({
  baseURL: getApiUrl(),
  headers: { 'Content-Type': 'application/json' },
});

patientAxios.interceptors.request.use((config) => {
  const token = sessionStorage.getItem(PATIENT_TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

patientAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.removeItem(PATIENT_TOKEN_KEY);
      window.location.reload();
    }
    reportHttpError(error);
    return Promise.reject(error);
  }
);

export async function getMyNewVisit() {
  const res = await patientAxios.get('/forms/me/new-visit');
  return res.data.result;
}

export async function saveMyNewVisit(
  data: Record<string, unknown>,
  status: 'inProgress' | 'submitted'
) {
  const res = await patientAxios.post('/forms/me/new-visit', {
    data: { data },
    status,
  });
  return res.data.result;
}

export async function getMyFollowUp() {
  const res = await patientAxios.get('/forms/me/followup');
  return res.data.result;
}

export async function getMyDiarySummary(windowEnd?: string) {
  const res = await patientAxios.get('/forms/me/diary-summary', {
    params: { windowEnd },
  });
  return res.data.result;
}

export async function saveMyFollowUp(
  data: Record<string, unknown>,
  status: 'inProgress' | 'submitted'
) {
  const res = await patientAxios.post('/forms/me/followup', { data, status });
  return res.data.result;
}
